import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { AuthService } from '../services/auth.service';
import { SessionService } from '../services/session.service';
@Component({
  standalone:true,
  imports:[
    CommonModule,
    FormsModule,
    RouterLink,
    RouterLinkActive
  ],

  template:`
  `
})
export class ViewAccountPage{
 token = '';
  whatsAppUrl = environment.whatsapp_url;
  constructor(private router: Router, 
              private route: ActivatedRoute, 
              private authService: AuthService,
              private sessionService: SessionService) {}
  ngOnInit() {
    this.token = this.route.snapshot.paramMap.get('token') ?? '';
    if (!this.token) {
        window.location.href = this.whatsAppUrl;
      return;
    }
    this.verifyToken();
  }
  verifyToken(){
    this.authService
    .postVerifyToken(this.token)
    .subscribe({
        next: response => {
          this.sessionService.setSession(response.sessionToken);
          this.sessionService.setUserId(response.userId);
          this.sessionService.setWalletBlance(response.walletBalance);
          this.router.navigate(['/']);
        },
        error: err => {
          if (err.status === 401) {
             this.router.navigateByUrl(
                '/Login/' + err.error?.userId,
                { replaceUrl: true }
              );
              return;
          }
          else if (err.status === 421) {
            this.router.navigateByUrl(
                '/setsecurityquestions/' + err.error?.userId,
                { replaceUrl: true }
              );
              return;
          }
          else if (err.status === 423) {
             this.router.navigateByUrl(
                '/unlockaccount/' + err.error?.userId,
                { replaceUrl: true }
              );
              return;
          }
          else{
           window.location.href = this.whatsAppUrl;
          }
        }
      },
    );
  }
}